import { definePart } from '../core/effect';
import { CARD_ASPECT } from '../core/field/zones';
import { drawCover, roundRectPath, rgba } from '../canvas/paint';

/**
 * **カードの絵**（Issue #537）。ドロー・召喚・移動で「そのカードそのもの」を見せるための素材。
 *
 * **絵は外から来る**（`cards.image(code)` / `cards.sleeve(player)`。素材の調達はページの仕事）。
 * `needsCard` を名乗るので、器が引いた絵を `deps` に入れて**読み込めた瞬間に描き直す**。
 *
 * `params.code` が無い（裏向き・分からない）ときは**スリーブ**、それも無ければ地の色。
 */
export default definePart({
  id: 'card',
  label: 'カードの絵',
  needsCard: true,
  size: { w: 280, h: 280 / CARD_ASPECT },
  schema: {
    code: { type: 'text', label: 'カード番号' },
    player: { type: 'number', label: 'プレイヤー', min: 0, max: 1, step: 1 },
    faceUp: { type: 'boolean', label: '表向き' },
    radius: { type: 'number', label: '角丸', min: 0, max: 40, step: 1 },
    glow: { type: 'color', label: '縁の色' },
    glowW: { type: 'number', label: '縁の太さ', min: 0, max: 24, step: 1 },
  },
  style: { code: '', player: 0, faceUp: true, radius: 12, glow: '#ffffff', glowW: 0 },

  draw(ctx, { size, style, cards }) {
    if (!(size.w > 0) || !(size.h > 0)) return;
    const r = style.radius * (size.w / 280);
    const img = style.faceUp === false ? null : cards?.image?.(style.code);
    const back = cards?.sleeve?.(style.player === 1 ? 1 : 0);
    const art = img ?? back ?? null;

    ctx.save();
    roundRectPath(ctx, 0, 0, size.w, size.h, r);
    ctx.clip();
    if (art) {
      drawCover(ctx, art, size.w, size.h);
    } else {
      // 絵が無いときの地（**読み込み中でも枠は出す** —— 何も出ないと「壊れた」に見える）
      ctx.fillStyle = style.faceUp === false ? '#2a2f4a' : '#3a3550';
      ctx.fillRect(0, 0, size.w, size.h);
    }
    ctx.restore();

    if (style.glowW > 0) {
      ctx.strokeStyle = rgba(style.glow, 0.9);
      ctx.lineWidth = style.glowW * (size.w / 280);
      roundRectPath(ctx, 0, 0, size.w, size.h, r);
      ctx.stroke();
    }
  },
});
